module.exports = __webpack_public_path__ + "media/conversa/ico_conversa_close-cf1750f8.png";